import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/adminWork-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IAdminWork } from 'src/types/adminWork';
import GeneralEnumService from 'src/enumerables/general-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { CellProps } from 'react-table';
import { ICase } from 'src/types/case';
import dropdownFilter from 'src/components/react-table/filters/dropdown-filter';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import moment from 'moment';
import { IInvoice } from 'src/types/invoice';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import AdminWorkActionsColumn from './AdminWorkActionsColumn';
import dateFilterMulti from 'src/components/react-table/filters/date-filter-multi';
import { numberWithCommas } from '../../../../../../../helpers/format';

interface Props {
    data: Paginated<IAdminWork>;
    providers: SelectObject[];
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
}

const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('AdminWorkStatus') : {};
const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);

const getColumns = (dataProd: SelectObject[]): Column<IAdminWork>[] => [
    {
        Header: 'Date',
        accessor: 'adminWorkDate',
        disableSortBy: true,
        headerClassName: 'text-center w-100 d-block',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IAdminWork>) => {
            return (
                <div className={'text-center'}>
                    {original.adminWorkDate ? moment(original.adminWorkDate).format('MMM D, YYYY') : ''}
                </div>
            );
        },
        Filter: dateFilterMulti<IAdminWork>(),
    },

    {
        Header: 'Provider',
        accessor: 'provider.id',
        disableSortBy: true,
        Filter: dropdownFilter<IAdminWork>(dataProd),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IInvoice>) => {
            if (!original?.provider) return '';

            return (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.provider?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                >
                    {original.provider?.fullName}
                </Link>
            );
        },
        // Filter: dropdownFilter<IAdminWork>(),
    },

    {
        Header: 'Start Time',
        accessor: 'startTime',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IAdminWork>) => (original.startTime ? changeToZeroMoment(original['startTime'], 'LT') : ''),
        Filter: textFilter<IAdminWork>(),
    },
    {
        Header: 'End Time',
        accessor: 'endTime',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IAdminWork>) => (original.endTime ? changeToZeroMoment(original['endTime'], 'LT') : ''),
        Filter: textFilter<IAdminWork>(),
    },
    {
        Header: 'Total Hours',
        accessor: 'totalHours',
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<IAdminWork>(),
    },
    {
        Header: 'Admin Rate',
        accessor: 'adminRate',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IAdminWork>) => {
            return original.adminRate ? `$${numberWithCommas(original.adminRate)}` : null;
        },
        Filter: textFilter<IAdminWork>(),
    },
    {
        Header: 'Total',
        accessor: 'totalAmount',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IAdminWork>) => {
            return original.totalAmount ? `$${numberWithCommas(original.totalAmount)}` : null;
        },
        Filter: textFilter<IAdminWork>(),
    },
    {
        Header: 'Comment',
        accessor: 'description',
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<IAdminWork>(),
    },
    {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueCaseStatus = statusItems.find((it) => it.value === original.status);
            return valueCaseStatus ? valueCaseStatus.label : '';
        },
        Filter: dropdownFilter<IAdminWork>(statusItems),

        // Filter: dropdownFilter<IAdminWork>(),
    },

    {
        Header: 'Actions',
        accessor: 'id',
        Cell: AdminWorkActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const AdminWorksGrid: React.FunctionComponent<Props> = ({ data, getData, getDataCsv, providers }: Props) => {
    const [columns, setColumns] = useState<any>([]);

    if (providers.length && !columns.length) {
        setColumns(getColumns(providers));
    }
    return (
        <div className={classNames(styles.grid)}>
            <Grid<IAdminWork> columns={columns} data={data} getDataCsv={getDataCsv} getData={getData} />
        </div>
    );
};

export default AdminWorksGrid;
